/* eslint-disable */ import { assertBoolean, attributeSwitchComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bendablePlateComponents = [
    attachComponent.withComponent(attributeSwitchComponent, 'hasBend', true).withAlias('BendablePlate').attach(memoEval((self)=>[
            self.hasBend
        ], (hasBend)=>({
            value: hasBend
        })), (state)=>{
        assertBoolean(state.value);
        return {
            hasBend: state.value
        };
    })
];

//# sourceMappingURL=bendable-plate.js.map